export default function () {
    return process.env.VUE_APP_SUPPORT_EMAIL;
}